const labelSubjectMap = {
  programEnrollment: 'program enrollment',
  installQuote: 'installation',
};

const actionSubjectMap = {
  programEnrollment: 'ProgramEnrollment',
  installQuote: 'Installation',
};

const toggleAddOnModel = (type, selected, category, eventCallback) => {
  const predicate = selected ? 'Add' : 'Remove';
  const labelSubject = labelSubjectMap[type] || 'product add-on';
  const actionSubject = actionSubjectMap[type] || 'ProductAddOn';

  return {
    event: 'trackEvent',
    category,
    label: `${predicate} ${labelSubject} in ${category}`,
    action: `${predicate}${actionSubject}In${category}`,
    eventCallback,
  };
};

export default toggleAddOnModel;
